import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from './client.js';

export interface WelfareCheckResponse {
  check_in: {
    id: string;
    user_id: string;
    scheduled_for: string;
    duration_minutes: number;
  };
  push_sent: number;
  push_failed: number;
  target_user: {
    id: string;
    display_name: string;
    phone_e164: string | null;
  };
}

export interface WelfareCheckInput {
  userId: string;
  durationMinutes?: number;
  message?: string;
}

export function useRequestWelfareCheck() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, durationMinutes, message }: WelfareCheckInput) =>
      api<WelfareCheckResponse>(`/users/${userId}/welfare-check`, {
        method: 'POST',
        body: JSON.stringify({
          duration_minutes: durationMinutes,
          message,
        }),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['roster'] });
      qc.invalidateQueries({ queryKey: ['check-ins'] });
    },
  });
}
